import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { authAPI } from '../utils/api'
import '../styles/auth.css'

const ForgotPasswordScreen = () => {
  const [email, setEmail] = useState('')
  const [loading, setLoading] = useState(false)
  const [submitted, setSubmitted] = useState(false)
  const [error, setError] = useState('')

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError('')
    setLoading(true)

    try {
      await authAPI.forgotPassword(email)
      setSubmitted(true)
    } catch (err) {
      setError(err.message || 'Failed to send reset email')
    } finally {
      setLoading(false)
    }
  }

  if (submitted) {
    return (
      <div className="auth-screen">
        <div className="auth-container">
          <div className="auth-form">
            <div className="auth-header">
              <h2>Check Your Email</h2>
              <p>If an account exists with that email, we've sent password reset instructions.</p>
            </div>
            <div style={{ textAlign: 'center', marginTop: '1.5rem' }}>
              <Link to="/auth" className="btn btn-primary">
                Back to Login
              </Link>
            </div>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="auth-screen">
      <div className="auth-container">
        <div className="auth-form">
          <div className="auth-header">
            <h2>Reset Password</h2>
            <p>Enter your email address and we'll send you a reset link</p>
          </div>

          <form onSubmit={handleSubmit} className="auth-form-content">
            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email"
                disabled={loading}
                required
              />
            </div>

            {error && <div className="error-message auth-error">{error}</div>}

            <button
              type="submit"
              className="btn btn-primary auth-submit"
              disabled={loading || !email}
            >
              {loading ? 'Sending...' : 'Send Reset Link'}
            </button>

            <div className="auth-switch">
              <p>
                Remember your password?{' '}
                <Link to="/auth" className="link-button">
                  Sign in
                </Link>
              </p>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}

export default ForgotPasswordScreen
